import { Button, Row } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../api/axiosClient";
import { Loading } from "../../components";

export default function Instructions() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  // May arrive without router state on the SSO deep-link path.
  const exam_instance = location.state?.exam_instance;

  useEffect(() => {
    if (!exam_instance?.id) {
      navigate("/my-session", { replace: true });
      return;
    }
    async function getQuestions() {
      try {
        setLoading(true);
        await axiosClient.get(`examinstances/${exam_instance.id}/questions`);
      } catch (error) {
        navigate("/my-session/not-verified", {
          state: location.state,
          replace: true,
        });
      } finally {
        setLoading(false);
      }
    }
    getQuestions();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="my-session-instructions-container">
      {loading ? <Loading /> : null}
      <div className="my-session-instructions">
        <h4 style={{ marginBottom: 20 }}>Instructions for Students</h4>
        <ol>
          <li>
            Check Your Equipment: Ensure your device (computer, tablet, or
            smartphone) is fully charged and connected to a stable internet
            connection. Have a backup power source if possible.
          </li>
          <li>
            Quiet Environment: Find a quiet, well-lit space where you won't be
            disturbed. Make sure you have all necessary materials (pen, paper,
            calculator, etc.) ready.
          </li>
          <li>
            Browser and Software: Use the recommended browser and make sure it
            is up to date. Close all other applications and browser tabs to
            avoid distractions and potential issues.
          </li>
          <li>
            Login Early: Log in to the exam platform at least 10-15 minutes
            before the exam starts to resolve any technical issues. Make sure
            you have your login credentials ready.
          </li>
          <li>
            Follow Exam Rules: Adhere to the specific guidelines provided for
            the exam, such as whether you are allowed to use notes, calculators,
            or other resources. Do not engage in any form of cheating.
          </li>
          <li>
            Time Management: Be aware of the exam duration. Keep an eye on the
            clock, and make sure to submit your answers before time runs out.
          </li>
          <li>
            Technical Support: Know how to reach technical support in case you
            encounter any issues during the exam. Keep the support contact
            information handy.
          </li>
        </ol>
      </div>
      <Row justify={"center"} style={{ marginTop: 30 }}>
        <Button
          type="primary"
          onClick={() =>
            navigate(`/my-session/active/${exam_instance?.id}`, {
              state: location.state,
            })
          }
        >
          Start Test
        </Button>
      </Row>
    </div>
  );
}
